import { decryptToAsciiString, encryptAsciiStringToHexString } from "../../dataEncryption";
import { collectLog, createEmptyLogsAndVars, dwReportError, recordVariable, } from "../../diagnostics/clientErrors";
const LOCALSTORAGE_KEY = "mpcWalletUserSharesJson";
export const hasSavedUserShares = () => {
    return localStorage.getItem(LOCALSTORAGE_KEY) !== null;
};
export const storeUserShares = async (provider, userSharesJson) => {
    const encodedUserSharesJson = await encryptAsciiStringToHexString(provider, userSharesJson);
    localStorage.setItem(LOCALSTORAGE_KEY, encodedUserSharesJson);
};
export const loadUserShares = async (provider) => {
    const logsAndVars = createEmptyLogsAndVars("userShareStorage:loadUserShares");
    try {
        const encodedUserSharesJson = localStorage.getItem(LOCALSTORAGE_KEY);
        recordVariable(logsAndVars, "encodedUserSharesJson from localStorage", encodedUserSharesJson);
        if (encodedUserSharesJson === null) {
            return null;
        }
        else {
            collectLog(logsAndVars, "Trying to decrypt user shares");
            return await decryptToAsciiString(provider, encodedUserSharesJson);
        }
    }
    catch (error) {
        dwReportError(null, undefined, error, { logsAndVars });
        return null;
    }
};
export const deleteUserShares = async () => {
    localStorage.removeItem(LOCALSTORAGE_KEY);
};
